<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">实训课堂日志</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-select v-model="formInline.region" placeholder="请选择组织结构">
            <el-option label="班级一" value="shanghai"></el-option>
            <el-option label="班级二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="班级名称">
          <el-input v-model="formInline.user" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="class_name" label="实训课名" width="140">
        </custom-table-column>
        <custom-table-column prop="class_at" label="上课时间" width="160">
        </custom-table-column>
        <custom-table-column prop="class_content" label="上课内容" width="180" show-overflow-tooltip>
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="预约电话" width="135">
        </custom-table-column> -->
        <custom-table-column prop="train_teacher" label="实训老师" width="100">
        </custom-table-column>
        <custom-table-column prop="people_number" label="出席人数" width="100">
        </custom-table-column>
        <custom-table-column prop="absense_number" label="缺席人数" width="100">
        </custom-table-column>
        <custom-table-column prop="absense_names" label="缺席人姓名" width="220">
        </custom-table-column>
        <custom-table-column prop="brief" label="简要记载" width="220" show-overflow-tooltip>
        </custom-table-column>
        <custom-table-column prop="summary" label="实训总结" width="220" show-overflow-tooltip>
        </custom-table-column>
        <!-- <custom-table-column prop="num5" label="备注" width="135">
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="实训课名" prop="class_name">
          <el-input v-model="ruleForm.class_name" placeholder="请输入实训课名" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训老师" prop="train_teacher_id">
          <el-select v-model="ruleForm.train_teacher_id" @change="handleInstituteChange" clearable style="width:216px;" filterable reserve-keyword
            :loading="loading" remote :remote-method="remoteMethod" placeholder="请输入名称搜索">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课时间" prop="class_at">
          <el-date-picker type="datetime" placeholder="选择上课时间" v-model="ruleForm.class_at"
            style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="上课内容" prop="class_content">
          <el-input v-model="ruleForm.class_content" placeholder="请输入上课内容" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="出席人数" prop="people_number">
          <el-input v-model.number="ruleForm.people_number" placeholder="请输入出席人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="缺席人数" prop="absense_number">
          <el-input v-model.number="ruleForm.absense_number" placeholder="请输入缺席人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="缺席人姓名" prop="absense_names">
          <el-input v-model="ruleForm.absense_names" placeholder="请输入缺席人姓名" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="简要记载" prop="brief">
          <el-input v-model="ruleForm.brief" placeholder="请输入简要记载" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="实训总结" prop="summary">
          <el-input type="textarea" v-model="ruleForm.summary" :rows="6" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteJournalOfClass">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      tearchers: [
        { sxid: '111', sxmc: '周宇' },
        { sxid: '222', sxmc: '徐德彪' },
      ],
      formInline: {
        user: '',
        region: '',
      },
      loading: false,
      ruleForm: {
        school_id: '',
        class_name: '',
        class_at: '',
        class_content: '',
        people_number: 0,
        absense_number: 0,
        absense_names: '',
        brief: '',
        summary: '',
        train_teacher: '',
        train_teacher_id: '',
      },
      users: [],
      ruleFormTep: {
        school_id: '',
        class_name: '',
        class_at: '',
        class_content: '',
        people_number: 0,
        absense_number: 0,
        absense_names: '',
        brief: '',
        summary: '',
        train_teacher: '',
        train_teacher_id: '',
      },
      rules: {
        class_name: [{ required: true, message: '请输入实训课名', trigger: 'blur' }],
        class_content: [{ required: true, message: '请输入上课内容', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入简要记载', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入实训总结', trigger: 'blur' }],
        class_at: [{ type: 'date', required: true, message: '请选择上课时间', trigger: 'change' }],
        people_number: [
          { required: true, message: '出席人数不能为空' },
          { type: 'number', message: '出席人数必须为数字值' },
        ],
        absense_number: [
          { required: true, message: '缺席人数不能为空' },
          { type: 'number', message: '缺席人数必须为数字值' },
        ],

        train_teacher_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      centerDialogVisible: false
    };
  },
  created() {
    if (this.$store.state.userInfo) {
      this.ruleForm.school_id = this.$store.state.userInfo.schoolid;
    }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    transformDate(e) {
      let timee = e.getTime() / 1000;
      this.ruleForm.class_at = this.$until.getTimeStr(timee, '-');
      console.log(this.ruleForm.class_at);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    handleEditInit(row) {
      if (row.train_teacher_id && JSON.stringify(this.users).indexOf(row.train_teacher_id) == -1) {
        this.users.push({ id: row.train_teacher_id, name: row.train_teacher })
      }
    }, handleInstituteChange(e) {
      this.ruleForm.train_teacher = this.$until.getLabelName(this.users, 'id', 'name', e);
    },
    async deleteJournalOfClass() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteJournalOfClass(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery()
      }
    },
    async createJournalOfClass() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.class_at) {
        let timee = params.class_at.getTime() / 1000;
        params.class_at = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createJournalOfClass(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateJournalOfClass() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let timee = ''
      if (typeof (params.class_at) == 'string') {
        timee = new Date(params.class_at).getTime() / 1000;
        params.class_at = this.$until.getTimeStr(timee, '-');
      } else {
        timee = params.class_at.getTime() / 1000;
        params.class_at = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.update.updateJournalOfClass(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      let res = await this.$api.query.getJournasOfClass(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      if (this.ruleForm.class_at) {
        this.ruleForm.class_at = new Date(this.ruleForm.class_at)
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createJournalOfClass();
          } else if (this.type == 'edit') {
            this.updateJournalOfClass();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
